<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-0">Informuojami asmenys</h3>

    <hipoteka-asmenys
      :asmuo-role="asmuoRole"
      :readonly="informavimasReadonly"
    />

    <template v-if="showPranesimai">
      <h3 class="mt-5 mb-3">Išsiųsti pranešimai</h3>

      <v-data-table
        class="mb-4"
        :loading="loading"
        :headers="filteredHeaders"
        :items="filterPranesimai"
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :items-per-page="pageSize"
      >
        <template #top>
          <v-toolbar flat
            ><v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label=""
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
        <template #[`item.zug_busena`]="{ item }">
          <el-busena :busena="item.zug_busena" />
        </template>
        <template #[`item.bylos`]="{ item }">
          <div class="nowrap">
            <el-byla
              v-for="byla in item.bylos"
              :key="byla.byl_id"
              :byla="byla"
            />
          </div>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="nowrap" v-if="item.zug_busena != 'Suformuotas'">
            <el-table-action :item="item" @resendItem="resendItem(item)" />
          </div>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template slot="loading">
          kraunasi
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <hipoteka-istorija duomenys="informavimas" />

    <modal-informavimas
      resend
      v-model="showResend"
      :item="modalResendItem"
      :readonly="informavimasReadonly"
      :rusis="modalResendRusis"
      @confirmResend="confirmResend"
    />

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        v-if="!informavimasReadonly"
        primary
        @click.native="checkErrors()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import busena from '../../mixins/busena'
import HipotekaMap from './hipotekaMap'
import HipotekaAsmenys from './HipotekaAsmenys'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'
import ModalInformavimas from './../modals/ModalInformavimas'

export default {
  name: 'HipotekaInformavimas',
  components: {
    HipotekaAsmenys,
    HipotekaIstorija,
    ModalInformavimas,
  },
  mixins: [userRole, busena, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,

      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      showResend: false,
      modalResendItem: {},
      modalResendRusis: null,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'hipotekaBusena',
      'hipotekaReadonly',
    ]),
    asmuoRole() {
      return HipotekaMap['asmenysRoles'].informuojamas
    },
    headers() {
      return [
        {
          text: 'Siųsto pranešimo registracijos numeris',
          align: 'start',
          value: 'zus_numeris',
        },
        {
          text: 'Siuntimo data ir laikas',
          align: 'start',
          value: 'zus_busenos_data',
        },
        {
          text: 'Adresatas',
          align: 'start',
          value: 'zus_adresatas',
        },
        {
          text: 'Adresato el. paštas',
          align: 'start',
          value: 'zus_adresato_el_pastas_text',
        },
        {
          text: 'Siųsto pranešimo rūšis',
          align: 'start',
          value: 'zus_dokumento_rusis',
        },
        {
          text: 'Siųsto dokumento būsena',
          align: 'start',
          value: 'zus_busena',
        },
        {
          text: 'Dokumentai',
          align: 'center',
          value: 'bylos',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          hide: !this.roleRG,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filterPranesimai() {
      return this.pranesimai.map(item => {
        item.zus_adresato_el_pastas_text = item.zus_adresato_el_pastas
          ? item.zus_adresato_el_pastas.replaceAll(',', ', ')
          : ''
        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: item.zus_numeris,
          }
        })

        item.canResend = true
        return item
      })
    },
    hideFooter() {
      return this.filterPranesimai.length <= 10
    },
    showPranesimai() {
      return (
        this.isIregistruotas ||
        this.isGrazintas ||
        this.isAtmestas ||
        this.isNepatikslintas
      )
    },
    informavimasReadonly() {
      return this.hipotekaReadonly || this.readonlyForm
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/issiustipranesimai`)
        .then(res => {
          this.pranesimai = res.data.pranesimai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    resendItem(item) {
      this.modalResendItem = Object.assign(
        {},
        {
          zus_id: item.zus_id,
          asm_pavadinimas: item.zus_adresatas,
          sasm_el_pastai: item.zus_adresato_el_pastas
            ? item.zus_adresato_el_pastas.split(',')
            : [],
        }
      )
      this.modalResendRusis = item.zus_dokumento_rusis_kodas
      this.showResend = true
    },
    confirmResend() {
      this.getData()
    },
  },
}
</script>
